import React from "react"
import { Outlet } from "react-router-dom"
import { GamesRouteProviders } from "routers/GamesRouteProviders"
import { Box, Stack } from "@mui/material"
import { styles } from "./AppEmbedLayout.styles"

export const AppEmbedLayoutUI = ({ children }) => {
  return (
    <Box>
      <Stack component="main" sx={styles.main}>
        <GamesRouteProviders>
          {children}
          <Outlet />
        </GamesRouteProviders>
      </Stack>
    </Box>
  )
}
